
























import Vue from "vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
// import { GenerateTransitionName } from "./router/routes";
import i18n from "./I18n";
import {
  CloneObj,
  ConsoleLog,
  ConvertBrowserLanguage,
  DeepClone,
} from "./utility";
import { mapGetters } from "vuex";
import { StoreAction, StoreGetter, StoreMutation } from "./store/store-mapping";
import config from "@/config/config.json";
import AuthService from "./services/AuthorService";
import APIService, { apiService } from "./services/APIService";
export default Vue.extend({
  name: "App",
  components: {
    loadingOverlay: LoadingOverlay,
  },

  data: () => ({
    version: config.app.version,
    isLoggedIn: false,
    loginError: "",
  }),
  computed: {
    ...mapGetters({
      userProfile: StoreGetter.umUserProfile,
    }),
  },
  methods: {
    setIsDebug() {
      const search = window.location.search;
      if (search.length === 0) {
        return;
      }
      const query = search.substring(1);
      const parameters = query.split("&");
      for (const item of parameters) {
        const pair = item.split("=");
        if (
          pair.length === 2 &&
          pair[0].toLocaleLowerCase() === "debug" &&
          pair[1].toLocaleLowerCase() === "true"
        ) {
          console.log("Vue.prototype.$isDebug = true;");
          Vue.prototype.$isDebug = true;
        }
      }
    },
    async initialLan() {
      const language = ConvertBrowserLanguage(window.navigator.language);
      ConsoleLog({
        "window.navigator.language": window.navigator.language,
        language: language,
      });
      Vue.prototype.$lanCode = language;
      const self = this as any;
      await self.$i18n.loadLanguageAsync(language);
    },
  },
  // watch: {
  //   // watch $route decide which style to use
  //   $route(to, from) {
  //     (this as any).transitionName = GenerateTransitionName(to, from);
  //   },
  // },
  async beforeMount() {
    // ConsoleLog({ "App.beforeMount": "a" });

    //Logging
    await this.$store.dispatch(StoreAction.umLogin);
    if (!this.userProfile) {
      this.isLoggedIn = false;
      return;
    }
    this.isLoggedIn = true;
    ConsoleLog({ "App.userProfile": DeepClone(this.userProfile) });
    // await this.initialLan();

    // await this.checkLogin();
    // self.$store.commit(StoreMutation.EndLoading);

    // if (self.userProfile) {
    //   ConsoleLog({ "userProfile.LanguageCode": self.userProfile.LanguageCode });
    //   Vue.prototype.$lanCode = self.userProfile.LanguageCode;
    //   await self.$i18n.loadLanguageAsync(self.userProfile.LanguageCode);
    //   self.$store.commit("EndLoading");
    // } else {
    //   await self.$i18n.loadLanguageAsync("zh-CN");
    // }
  },
  async mounted() {
    ConsoleLog({
      "app.mounted.window.navigator.language": window.navigator.language,
    });
    await this.initialLan();
  },
  async created() {
    (this as any).setIsDebug();
    // ConsoleLog({
    //   "App.created": "a",
    // });
  },
  beforeCreate() {
    // ConsoleLog({
    //   "App.beforeCreate": "a",
    // });
  },
});
